import { AxiosError } from 'axios';
import { useLocation, useNavigate } from 'react-router';

import { AppMessage } from '@/common/components';
import { useAuthState, useNetworkErrorState } from '@/common/hooks';
import { messageOnError } from '@/common/utils';

import { useGetSessionAuthMutation } from '@/modules/Auth';
import { UserPosition } from '@/modules/Users';


export const useFetchSessionUser = () => {
  const { setSessionUser, setAuthingState } = useAuthState();
  const navigate = useNavigate();
  const appMessageApi = AppMessage.useControls();
  const { pathname } = useLocation();
  const { setNetworkErrorState } = useNetworkErrorState();

  const { isLoading } = useGetSessionAuthMutation()({
    onSuccess: (user) => {
      let currentTeamId: string | null = null;
      // let currentTeamId = user.position === UserPosition.Administrator ? null : user.teams[0]?.id || null;
      // if (localStorage.getItem('currentTeamId')) {
      //   currentTeamId = localStorage.getItem('currentTeamId') === 'null' ? null : localStorage.getItem('currentTeamId');
      // } else {
      //   localStorage.setItem('currentTeamId', currentTeamId || 'null');
      // }
      if (user.position === UserPosition.Administrator) {
        currentTeamId = null;
      } else {
        currentTeamId = null;
        const teamId = localStorage.getItem('currentTeamId');
        if (!teamId || teamId === 'null') {
          if (user.teams.some(({ id }) => teamId === id)) {
            currentTeamId = teamId;
          } else {
            currentTeamId = user.teams[0]?.id || null;
          }
        } else currentTeamId = user.teams[0]?.id || null;
      }

      localStorage.setItem('currentTeamId', currentTeamId || 'null');

      setSessionUser({ ...user, currentTeamId });
      setAuthingState(true);

      navigate(pathname);
    },
    onError: (error) => {
      setSessionUser(null);

      if (error instanceof AxiosError) {
        if (error.code === 'ERR_NETWORK') {
          setNetworkErrorState(true);
        } else if (error.response?.status === 401) {
          setAuthingState(false);
        } else {
          messageOnError(error, appMessageApi);
        }
      }
    }
  });

  return { isLoading };
};
